import { paramObjFromURL, searchIDFromData } from '../utils/parse.js';

const categoryFromIntOrString = {
    6: 'model',
    8: 'image',
    9: 'audio',
    14: 'video',
    10: 'mesh',
    7: 'plugin',
    'Models': 'model',
    'Decals': 'image',
    'Audio': 'audio',
    'Video': 'video',
    'Meshes': 'mesh',
    'Plugins': 'plugin'
};
const sortTypeFromInt = {
    0: 'Relevance',
    1: 'MostFavorited',
    2: 'Bestselling',
    3: 'RecentlyUpdated',
    4: 'PriceLowToHigh',
    5: 'PriceHighToLow'
};
const sortAggregationFromInt = {
    5: 'AllTime',
    3: 'PastWeek',
    1: 'PastDay'
};

function populateMarketplaceLibrarySearchEvent(autocompleteMetrics, data, url) {
    const newSearchID = searchIDFromData(data);
    const queryObj = paramObjFromURL(url);
    const assetType = categoryFromIntOrString[(queryObj.get('Category'))] || null;
    const sortType = sortTypeFromInt[(queryObj.get('SortType') || 0)];
    const searchKeyword = decodeURIComponent(queryObj.get('Keyword') || '');
    const creatorID = parseInt((queryObj.get('CreatorID') || ''));
    const creatorName = (queryObj.get('CreatorName') || '');
    const autocompleteShown = (Roblox.LibraryAutocompleteParameters) ? Roblox.LibraryAutocompleteParameters.autocompleteShouldShow : false;
    let sortAggregation = sortAggregationFromInt[queryObj.get('SortAggregation')] || null;

    if (sortType !== 'MostFavorited' && sortType !== 'Bestselling') {
        // SortAggregation is only applicable for MostFavorited and BestSelling
        sortAggregation = null;
    }
    
    if (typeof autocompleteMetrics === typeof undefined) {
        // First loading of Library and back/forward buttons
        autocompleteMetrics = {
            autocompleteShown: autocompleteShown,
            autocompletePrefix: null,
            autocompleteKeyCount: 0,
            autocompleteBackspaceCount: 0,
            searchKeyword: searchKeyword,
            searchID: newSearchID,
            assetType: assetType,
            sortType: sortType,
            sortAggregation: sortAggregation,
            creatorID: (!isNaN(creatorID)) ? creatorID : null,
            creatorName: creatorName,
            context: 'Library',
        };
    }
    else {
        // Happens when user searches with a keyword
        autocompleteMetrics.autocompleteShown = autocompleteShown;
        autocompleteMetrics.searchID = newSearchID;
        autocompleteMetrics.searchKeyword = searchKeyword;
        autocompleteMetrics.assetType = assetType;
        autocompleteMetrics.sortType = sortType;
        autocompleteMetrics.sortAggregation = sortAggregation;
        autocompleteMetrics.creatorID = (!isNaN(creatorID)) ? creatorID : null;
        autocompleteMetrics.creatorName = creatorName;
        autocompleteMetrics.context = 'Library';
    }
    
    return autocompleteMetrics;
}

export { populateMarketplaceLibrarySearchEvent };